import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=53744614"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53744614')) {
      api.createRecord('53744614', component.options)
    } else {
      api.reload('53744614', component.options)
    }
    module.hot.accept("./HistoryDetail.vue?vue&type=template&id=53744614", function () {
      api.rerender('53744614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/HistoryDetail.vue"
export default component.exports